import './application_menu.css';

/*
 * Description: Application Menu Web Component
 * Purpose: A reusable sidebar navigation menu with logo, label, and a list of menu options
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - Displays a logo with a label
 * - Hosts application-menu-option children in a navigation list
 * 
 * Usage:
 * <application-menu label="CoconutJS">
 *   <application-menu-option pageId="home" icon="bx-home"></application-menu-option>
 * </application-menu>
 * 
 * Attributes:
 *    -
 */

class application_menu extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const internalContent=this.innerHTML;
        const label = this.getAttribute("label");
        this.innerHTML = `        
        <div class="l-navbar" id="nav-bar">
                <nav class="nav">                    
                    <div>
                        <div class="nav_list"> 
                            ${internalContent}
                        </div>
                    </div>                     
                </nav>
            </div>`;
        this.dataset.rendered = "true";
    }
}

export { application_menu };